module.exports = __webpack_public_path__ + "assets/normal/images/wheat_ears_small.960b3274.png";